import { Whisper, Avatar, Tooltip } from "rsuite";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import {
  getPkgServiceMeta,
  StyleTypeContext,
  TranslationContext,
} from "../../umbilical_tools";
import { InlineIcon } from "@iconify/react";
import pkgAirplaneIcon from "../icons/pkgAirplaneIcon.svg";
import pkgAccommodationIcon from "../icons/pkgAccommodationIcon.svg";
import pkgMapMarkerIcon from "../icons/pkgMapMarkerIcon.svg";
import pkgCarIcon from "../icons/pkgCarIcon.svg";
import jssVariables from "../../jss_setup";

export const genericDescriptionStyles = {
  Description: {
    overflow: "hidden",
    textAlign: "justify",
    height: "max-content",
    margin: "0.75rem 0",
    display: "-webkit-box",
    minHeight: "5rem",
    [`-webkit-box-orient`]: "vertical",
    [`-webkit-line-clamp`]: 6,
    smallscreen: {},
    bigscreen: {},
  },
};

const serviceTypesStyles = createUseStyles({
  serviceTypes: (props) => ({
    display: "grid",
    gridAutoFlow: "column",
    gridAutoColumns: "min-content",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.serviceTypes", {}),
  }),
  serviceIcon: (props) => ({
    background: props.baseColor,
    ..._.get(props, "customStyles.serviceIcon", {}),
  }),
});
export const ServiceTypes = (props) => {
  const { tour, baseColor, customStyles } = props;
  const { type } = useContext(StyleTypeContext);

  const { hasFl, accNo, hasAcc, addOnNo, hasAddOn, trfNo, hasTrf } =
    getPkgServiceMeta(tour);

  const classes = serviceTypesStyles({ baseColor, customStyles });
  const { t } = useContext(TranslationContext);

  return (
    <div className={classes.serviceTypes}>
      {hasFl ? (
        <Whisper placement="top" speaker={<Tooltip>{t("flights")}</Tooltip>}>
          <Avatar size="sm" className={classes.serviceIcon}>
            {type !== "type2" ? (
              <InlineIcon icon="fa:plane" />
            ) : (
              <img src={pkgAirplaneIcon} alt="" />
            )}
          </Avatar>
        </Whisper>
      ) : null}
      {hasAcc ? (
        <Whisper
          placement="top"
          speaker={<Tooltip>{`${t("accommodation")} (${accNo})`}</Tooltip>}>
          <Avatar size="sm" className={classes.serviceIcon}>
            {type !== "type2" ? (
              <InlineIcon icon="fa:h-square" />
            ) : (
              <img src={pkgAccommodationIcon} alt="" />
            )}
          </Avatar>
        </Whisper>
      ) : null}
      {hasTrf ? (
        <Whisper
          placement="top"
          speaker={<Tooltip>{`${t("transfers")} (${trfNo})`}</Tooltip>}>
          <Avatar size="sm" className={classes.serviceIcon}>
            {type !== "type2" ? (
              <InlineIcon icon="fa6-solid:car" />
            ) : (
              <img src={pkgCarIcon} alt="" />
            )}
          </Avatar>
        </Whisper>
      ) : null}
      {hasAddOn ? (
        <Whisper
          placement="top"
          speaker={
            <Tooltip>{`${t("tours")}/${t("experiences")}(${addOnNo})`}</Tooltip>
          }>
          <Avatar size="sm" className={classes.serviceIcon}>
            {type !== "type2" ? (
              <InlineIcon icon="fa:map-marker" />
            ) : (
              <img src={pkgMapMarkerIcon} alt="" />
            )}
          </Avatar>
        </Whisper>
      ) : null}
    </div>
  );
};
ServiceTypes.defaultProps = {
  baseColor: jssVariables.colors.base_color,
  customStyles: {},
};
ServiceTypes.propTypes = {
  baseColor: PropTypes.string,
  tour: PropTypes.object.isRequired,
  customStyles: PropTypes.object.isRequired,
};

export const ratingStyles = {
  borderRadius: jssVariables.normal_gap,
  background: "white",
  boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
  padding: `calc(${jssVariables.normal_gap} / 3) ${jssVariables.normal_gap}`,
};
